// Remembers which content page (movie/series) the viewer pressed play from,
// keyed by the playback route's own uuid (movie uuid or episode uuid).
//
// Why this exists: the player's back button used to call window.history.back().
// When playback was reached through the "not logged in" redirect chain
// (content page -> /login -> /verify or /register -> playback page), the
// login pages sit in browser history *between* the content page and the
// player, so history.back() from the player lands back on /login — which,
// now that the viewer is authenticated, just bounces them again. Storing the
// origin explicitly lets the back button return straight to the content page
// regardless of what login steps happened to be in between.
//
// sessionStorage (not localStorage) because this is only meaningful for the
// tab's current browsing session.
const PREFIX = "playback-origin:";

export function savePlaybackOrigin(playbackUuid: string, originPath: string) {
  if (!playbackUuid || !originPath) return;
  try {
    sessionStorage.setItem(`${PREFIX}${playbackUuid}`, originPath);
  } catch {
    // sessionStorage unavailable (private mode, etc.) — back button falls
    // back to history.back(), so nothing else to do here.
  }
}

export function getPlaybackOrigin(playbackUuid: string): string | null {
  if (!playbackUuid) return null;
  try {
    return sessionStorage.getItem(`${PREFIX}${playbackUuid}`);
  } catch {
    return null;
  }
}
